module.exports = __webpack_public_path__ + "img/roma-logo-icon.601aafde.png";